import { Svg, SvgPath, SvgProps } from '@rbilabs/universal-components';
import { Rect } from 'react-native-svg';

export const RemoveICon = (props: SvgProps) => {
  return (
    <Svg width={props.size || 28} height={props.size || 28} viewBox="0 0 28 28" fill="none">
      <Rect
        x="0.583333"
        y="0.583333"
        width="26.8333"
        height="26.8333"
        rx="13.4167"
        stroke={props.fill || '#502314'}
        strokeWidth="1.16667"
      />

      <SvgPath fill={props.fill || '#502314'} d="M18.764 14.6806H9.23621V13.3195H18.764V14.6806Z" />
    </Svg>
  );
};
